import { useState } from "react";
import { getLoanBalance, cediSign } from "../../utils/constants";
import { Reversal, Repay } from "../../components";
import { HugeiconsIcon } from '@hugeicons/react';
import { Money01Icon, RepeatIcon, Alert01Icon, CheckmarkCircle01Icon } from '@hugeicons/core-free-icons';

function LoanState({ loan }) {

    const payments = loan?.ledgerRows?.filter(item => item.capital === null || item.capital === undefined) || [];
    const outstandingBalance = loan?.accountInfo
        ? (loan.accountInfo.totalPayment - getLoanBalance(payments)).toFixed(2)
        : null;

    const [repayIsOpen, setRepayIsOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    if (outstandingBalance === null) return null;

    const isPaidOff = outstandingBalance <= 0;
    const isDelinquent = loan?.state === "active" && loan?.daysInDelinq > 0;

    if (isPaidOff) {
        return (
            <div className="flex items-center gap-3 bg-emerald-50 border border-emerald-100 rounded-xl px-5 py-4">
                <div className="w-9 h-9 rounded-full bg-emerald-100 flex items-center justify-center shrink-0">
                    <HugeiconsIcon icon={CheckmarkCircle01Icon} size={18} className="text-emerald-600" />
                </div>
                <div>
                    <p className="text-sm font-semibold text-emerald-700">Loan fully paid off</p>
                    <p className="text-xs text-emerald-500 mt-0.5">All payments have been received.</p>
                </div>
            </div>
        );
    }

    return (
        <>
        <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm p-5 space-y-4">
            <div className="flex items-start sm:items-center justify-between flex-col sm:flex-row gap-4">
                <div>
                    <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-1">Outstanding Balance</p>
                    <p className="text-3xl font-bold text-gray-900 dark:text-gray-50 tabular-nums">
                        {cediSign} {outstandingBalance}
                    </p>
                    <p className="text-xs text-gray-400 mt-1">
                        <span className="font-semibold text-gray-600 dark:text-gray-300">{payments?.length}</span> of{' '}
                        <span className="font-semibold text-gray-600 dark:text-gray-300">{loan?.accountInfo?.numPayments}</span> payments made
                    </p>
                </div>

                <div className="flex items-center gap-2">
                    <button
                        type="button"
                        onClick={() => setRepayIsOpen(true)}
                        className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors"
                        style={{ backgroundColor: '#1e3a6e' }}
                    >
                        <HugeiconsIcon icon={Money01Icon} size={15} />
                        Make Payment
                    </button>

                    <button
                        type="button"
                        onClick={() => setIsOpen(true)}
                        className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition-colors"
                    >
                        <HugeiconsIcon icon={RepeatIcon} size={15} className="text-gray-500 dark:text-gray-400" />
                        Reversal Request
                    </button>
                </div>
            </div>

            {isDelinquent && (
                <div className="flex items-start gap-3 bg-red-50 dark:bg-red-500/10 border border-red-100 dark:border-red-500/20 rounded-lg px-4 py-3">
                    <HugeiconsIcon icon={Alert01Icon} size={16} className="text-red-500 shrink-0 mt-0.5" />
                    <p className="text-sm text-red-700 dark:text-red-400">
                        Client is <span className="font-bold">{loan.daysInDelinq}</span> days behind in payments. Please alert the client to make payment to avoid penalties.
                    </p>
                </div>
            )}
        </div>

        <div className="hidden">
            <Repay
                isOpen={repayIsOpen}
                closeModal={() => setRepayIsOpen(false)}
                loan={loan}
            />
            <Reversal
                isOpen={isOpen}
                closeModal={() => setIsOpen(false)}
                loanId={loan?.loanId}
                loanType={loan?.type}
                phone={loan?.phone}
                client={loan?.client?.otherNames + ' ' + loan?.client?.surname}
            />
        </div>
        </>
    );
}

export default LoanState;
